export default [
  {
    name: 'Gluten',
    value: 'GLUTEN'
  },
  {
    name: 'Crustaceans',
    value: 'CRUSTACEANS'
  },
  {
    name: 'Eggs',
    value: 'EGGS'
  },
  {
    name: 'Fish',
    value: 'FISH'
  },
  {
    name: 'Peanuts',
    value: 'PEANUTS'
  },
  {
    name: 'Nuts',
    value: 'NUTS'
  },
  {
    name: 'Soybeans',
    value: 'SOYBEANS'
  },
  {
    name: 'Milk',
    value: 'MILK'
  },
  {
    name: 'Celery',
    value: 'CELERY'
  },
  {
    name: 'Mustard',
    value: 'MUSTARD'
  },
  {
    name: 'Sesame',
    value: 'SESAME'
  },
  {
    name: 'Lupin',
    value: 'LUPIN'
  },
  {
    name: 'Sulphur dioxide',
    value: 'SULPHUR_DIOXIDE'
  }
]
